import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../global.service';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';

@Component({
  selector: 'app-club',
  templateUrl: './club.component.html',
  styleUrls: ['./club.component.sass']
})
export class ClubComponent implements OnInit {
  public tabActive='Mis Equipos y Servicios';
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public selectBan;
  public token:string=sessionStorage.getItem("token");
  public content:object;
  public color;
  constructor(public AngularFireAnalytics:AngularFireAnalytics,public global:GlobalService,private loadingScreenService: LoadingScreenService) {
    this.AngularFireAnalytics.setCurrentScreen("Claro Club");
    this.AngularFireAnalytics.logEvent("Claro Club-Screenview");
   }

  ngOnInit() {
    this.color=false;
    this.content={
      content:[
        {
          title:"¿Cómo funciona Claro Club?",
          description:"• Para pertenecer al <b>Claro Club</b> tienes que ser cliente activo de culaquier servicio de Claro.<br><br>• Descargar el app de BUREA en tu tienda de aplicaciones Android o Apple.<br><br>• Los comercios que participen del programa te brindarán recompensas y ofertas a modo de dinero devuelto o CASHBACK que podrás transferir a tu cuenta de banco, cooperativa o PayPal.",
          expand:true
        },
        {
          title:"¿Cómo te beneficias de las ofertas del Claro Club?",
          description:"• Sigue los siguientes pasos para que puedas disfrutar del programa y sus beneficios exclusivos:<ul><li>Descarga el app de <b>BUREA</b>® en tu iPhone o Android</li><li>Regístrate con tu información</li><li>Busca las ofertas exclusivas del Claro Club en el app.  Las ofertas estarán identificadas con ícono que dice “Claro Club”.</li><li>Una vez visites los comercios y compres los productos en oferta, sube una foto de tu recibo de compra.</li><li>En menos de 72 horas. estaremos validando tu recibo y te acreditaremos el CASHBACK establecido en la oferta directito a tu cuenta de BUREA.</li><li>Una vez acumules $20 o más, puedes transferir el <b>CASHBACK </b>acumulado a una cuenta de banco, cooperativa.</li></ul>",
          expand: false
        }
      ]
    };
    this.loadingScreenService.stopLoading();
  }
  initializeData(){
    this.global.refreshDataTo(this.token);
  }

}
